import DueDiligenceDeleteModal from './DueDiligenceDeleteModal';

export default DueDiligenceDeleteModal;
